import { render, staticRenderFns } from "./CourseBuilderB.vue?vue&type=template&id=228f6d33&scoped=true&"
import script from "./CourseBuilderB.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderB.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderB.vue?vue&type=style&index=0&id=228f6d33&lang=scss&scoped=true&"
import style1 from "./CourseBuilderB.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f6d33",
  null
  
)

export default component.exports